import React from "react";
import "./Header.scss";
import { motion } from "framer-motion";
import { images } from "../../constants";
import { AppWrapper } from "../../wrapper";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};
const Header = () => {
  return (
    <>
      <div className="app__header app__flex">
        <motion.div
          whileInView={{ x: [-300, 0], opacity: [0, 1] }}
          transition={{ duration: 1, ease: "easeInOut" }}
          className="app__header-info"
        >
          <div className="app__header-badge">
            <div className="badge-cmp app__flex">
              <span>
                <img
                  src="https://c.tenor.com/yWSRmymbuBkAAAAM/waving-hi.gif"
                  alt=""
                />
              </span>
              <div style={{ marginLeft: 20 }}>
                <p className="p-text">Hello, I am</p>
                <h1 className="head-text">Ramit</h1>
              </div>
            </div>

            <div className="tag-cmp app__flex">
              <p className="p-text">Web Developer</p>
              <p className="p-text">Programmer</p>
            </div>
          </div>
        </motion.div>
        <motion.div
          whileInView={{ opacity: [0, 1] }}
          transition={{ duration: 0.5, delayChildren: 0.5 }}
          className="app__header-img"
        >
          <img
            onClick={(e) => {
              e.preventDefault();
              alert("You received a bonk! Dont click me again!");
            }}
            src="https://us.123rf.com/450wm/sirvectorr/sirvectorr2004/sirvectorr200400147/145656255-developer-line-icon-vector-outline-illustration-of-man-in-glasses-hipster-student-pictorgam.jpg?ver=6"
            alt="profile_bg"
          />
          <motion.img
            whileInView={{ scale: [0, 1] }}
            transition={{ duration: 1, ease: "easeInOut" }}
            src={images.circle}
            alt="profile_circle"
            className="overlay_circle"
          />
        </motion.div>
        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="app__header-circles"
        >
          {[images.nodejs, images.redux, images.mongodb, images.sass].map(
            (circle, index) => (
              <motion.div
                whileHover={{ scale: [1, 0.8], cursor: "pointer" }}
                className="circle-cmp app__flex"
                key={`circle-${index}`}
              >
                <motion.img src={circle} alt="profile_bg" />
              </motion.div>
            )
          )}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrapper(Header, "home");
